export enum PaymentMethods {
    CreditCard = 'credit_card',
    BankAch = 'bank_ach',
    BankWire = 'bank_wire',
    Cryptocurrency = 'cryptocurrency',
    MailACheck = 'mail_a_check'
}
